// Payments module routes.
//
//   /payment         the list: every bill and where it stands, and every payment
//   /payment/queue   the payments team's worklist (US-16)
//
// A LIST ONLY. Taking a payment, adding an instrument, AutoPay, refunds, fees and
// the regulated programmes all moved to Account Detail → Payments on 2026-10-07,
// because every one of them is something done to a CUSTOMER and that page already
// knows which. The invoice-keyed detail page they briefly lived on had to ask for
// an account reference on four of its seven tabs, which was the clue.
//
// A bill row therefore opens `/accounts/:accountUid?tab=payments`, not a page
// here — the list is the way IN to the work, not the place it happens.

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const PaymentsListPage = lazy(() =>
  import('./pages/PaymentsListPage').then((m) => ({ default: m.PaymentsListPage })),
);
const PaymentsQueuePage = lazy(() =>
  import('./pages/PaymentsQueuePage').then((m) => ({ default: m.PaymentsQueuePage })),
);

export const paymentRoutes: RouteObject[] = [
  { path: '/payment', element: <PaymentsListPage /> },
  { path: '/payment/queue', element: <PaymentsQueuePage /> },
];
